// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"764a3c9d","691":"5096a74d","716":"764a3c9d","762":"6a591767","801":"11a8ee4e","893":"764a3c9d"}[chunkId] + ".chunk.css";
};